import i18n from 'shared/lib/i18n';

export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

// regex for hh:mm:ss or h:mm:ss
export const TIME_REGEX = /(?:[01]\d|2[0123]):(?:[012345]\d):(?:[012345]\d)/;

export const DEFAULT_START_TIME = '00:00:00';
export const DEFAULT_END_TIME = '23:59:00';
export const DEFAULT_END_ANY_TIME = '23:59:59';

export const DEFAULT_SCHEDULE = {
  everyday: {
    isOn: true,
    timeSlots: [
      { startTime: DEFAULT_START_TIME, endTime: DEFAULT_END_ANY_TIME },
    ],
  },
};

export function errorMessages() {
  return {
    everyDayError: i18n.t('schedule.errors.everyDayError'),
    emptyScheduleError: i18n.t('schedule.errors.emptyScheduleError'),
    invalidTimeError: i18n.t('schedule.errors.invalidTimeError'),
    invalidTimeIntervalError: i18n.t(
      'schedule.errors.invalidTimeIntervalError',
    ),
    alreadyExists: i18n.t('schedule.errors.alreadyExists'),
    timeOverlapError: i18n.t('schedule.errors.timeOverlapError'),
  };
}

export const DAYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];
